<template>
  <div id="app">
		<router-view></router-view>
  </div>
</template>

<script>
import Index from './views/index/index.vue'

export default {
  name: 'app',
  components: {
    Index
  }
}
</script>

<style>
	 #app{
		 background: #F7F7F7;
	 }
</style>
